import { API_GET_ASPEN_GRAPH, API_GET_MAX_USER_DATA } from "../ApiConstants";
import axios from "../client/rest";

class DashboardApi {
  static sharedInstance = new DashboardApi();

  constructor() {
    if (DashboardApi.sharedInstance !== null) {
      return DashboardApi.sharedInstance;
    }
  }

  async getMaxUserDataGraph() {
    try {
      const res = await axios.get(API_GET_MAX_USER_DATA);
      if (res.status === 200) {
        return res.data.data;
      } else {
        throw "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }

  async getAspenGraph() {
    try {
      const res = await axios.get(API_GET_ASPEN_GRAPH);
      if (res.status === 200) {
        return res.data.data;
      } else {
        throw "Something went wrong";
      }
    } catch (err) {
      throw err;
    }
  }
}

export default DashboardApi.sharedInstance;
